<template>
<main>
  <header class="margin-top">
        <div id="mycarousel" class="carousel slide carousel-fade" data-ride="carousel" >
            <div class="carousel-inner font-weight-lighter">
                <div class="carousel-item">
                    <img :src="require('@/assets/images/portada1.jpg')" class="d-block w-100">
                    <div class="carousel-caption mb-md-5 text-left d-none d-md-block">
                        <h4>{{ carousel.T1 }}</h4>
                        <h1 class="mb-lg-5 pb-lg-5 font-cursive">{{ carousel.P1}}</h1>
                      </div>
                </div>
                <div class="carousel-item">
                    <img :src="require('@/assets/images/portada2.jpg')" class="d-block w-100">
                    <div class="carousel-caption mb-md-5 text-left d-none d-md-block">
                        <h1 class="font-cursive">{{ carousel.T2 }}</h1>
                        <h4 class="mb-lg-5 pb-lg-5">{{ carousel.P2 }}</h4>
                    </div>
                </div>
                <div class="carousel-item active">
                    <img :src="require('@/assets/images/portada3.jpg')" class="d-block w-100">
                    <div class="carousel-caption text-left d-none d-md-block" style="top:7.5rem; bottom:2rem; left:10%; right:10%; background: rgba(255,255,255,0.8)">
                      <div class="container" style="color:#000;">
                        <div class="row justify-content-center">
                          <div class="col-5 d-flex align-items-center justify-content-end mt-3">
                            <h2 class="font-cursive mb-0 mt-0">{{ carousel.T3 }}</h2>
                          </div>
                          <div class="col-6 d-flex align-items-center justify-content-left row">
                            <div class="col-md-10">
                              <img :src="require('@/assets/images/prime_global_logo.png')" alt="" class="img-fluid">
                            </div>
                          </div>
                          <div class="col-11 mt-3">
                            <p style="font-weight:500;">{{ carousel.P3 }}</p>
                          </div>
                          <div class="col-10 d-xl-block d-none mb-4">
                            <div class="row">
                              <div class="col-sl-4 col-2 text-center d-flex flex-column align-items-center justify-content-center" v-for="(item, index) in globes" :key="index">
                               <div style="width:120px; height:120px;" class="d-flex align-items-end justify-content-center pb-2">
                                  <img :src="item.image" alt="" class="img-fluid">
                               </div>
                                <h5 class="mb-0 font-weight-bold">{{ item.title }}</h5>
                                <h5 class="mb-0 font-weight-normal">{{ item.data }}</h5>
                              </div>
                            </div>
                          </div>
                          <div class="col-9 text-center">
                            <p style="font-weight:500;">{{ carousel.SP3 }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#mycarousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#mycarousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
        <div style="background:#002548;">
            <div class="container py-5 font-weight-light">
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex">
                            <h3 class="text-white border-super-bottom border-danger pb-2 pr-2">{{ principles.title }}</h3>
                        </div>
                    </div>
                    <div class="col-md-7 pr-5">
                        <p class="text-white">{{ principles.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <section>
      <div class="container py-5 text-justify">
        <div class="row justify-content-center font-weight-light px-3">
          <div class="col-lg-4 col-md-6 px-0">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <img :src="require('@/assets/iconos/ico_1.svg')" height="50" alt="">
                  <h4 class="my-auto ml-3 font-cursive">{{ lang == 'es' ? 'Misión' : 'Mission' }}</h4>
                </div>
                <p class="text-lead mt-3">{{ mission }}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 px-0">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <img :src="require('@/assets/iconos/ico_2.svg')" height="50" alt="">
                  <h4 class="my-auto ml-3 font-cursive">{{ lang == 'es' ? 'Visión' : 'Vision' }}</h4>
                </div>
                <p class="text-lead mt-3">{{ vision }}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 px-0">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <img :src="require('@/assets/iconos/ico_3.svg')" height="50" alt="">
                  <h4 class="my-auto font-weight-lighter ml-3 font-cursive">{{ lang == 'es' ? 'Valores' : 'Values' }}</h4>
                </div>
                <p class="text-lead mt-3">
                  <ul>
                      <li class="mb-3">
                          <span class="font-weight-bold">{{ values[0].title }}:</span> {{ values[0].description }}
                      </li>
                      <a class="text-info border-bottom border-info" style="cursor:pointer;" data-toggle="modal" data-target="#valors">
                        {{ lang == 'es' ? 'Ver más' : 'See more' }}
                      </a>
                  </ul>
                </p>
                <div class="modal fade bd-example-modal-lg" id="valors" tabindex="-1" role="dialog" aria-labelledby="valorsLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title pl-3 font-cursive" id="valorsLabel">{{ lang == 'es' ? 'Valores' : 'Values' }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body text-lead">
                        <ul v-for="(item, index) in values" :key="index">
                          <li class="mb-3 pr-4" v-if="index > 0">
                              <span class="font-weight-bold">{{ item.title }}:</span> {{ item.description }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-6 pt-5">
            <router-link class="btn btn-dan rounded-0 text-white btn-lg btn-block" :to="{name:'about'}"><small>{{ lang == 'es' ? 'CONOZCA MÁS DE NOSOTROS' : 'LEARN MORE ABOUT US' }}</small></router-link>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container font-weight-light pb-3">
        <div class="row justify-content-center">
          <div class="col-12 mb-5">
            <h3 class="font-cursive">{{ title }}</h3>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-4 col-5 text-center" v-for="(item, index) in images" :key="index">
            <div class="row justify-content-center px-md-3 px-2 h-100">
              <div class="col-lg-6 col-md-8 col-11">
                <img :src="item.img" alt="" class="img-fluid mb-3">
              </div>
              <div class="col-12 border-medio-bottom border-icons mb-5 pb-3">
                <h5 class="text-lead mb-0">{{ item.title }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="card bg-dark text-white vh-100 rounded-0">
        <img :src="require('@/assets/images/control_de_calidad.jpg')" class="card-img h-100">
        <div class="card-img-overlay">
          <div class="container h-100 text-justify font-weight-light">
            <div class="row align-items-center h-100 justify-content-center">
              <div class="col-lg-5 col-md-8">
                <h2>{{ control.title }}</h2>
                <p class="font-weight-light">{{ control.description }}</p>
              </div>
              <div class="col-lg-5 col-md-8">
                <h2>{{ confidentiality.title }}</h2>
                <p class="font-weight-light">{{ confidentiality.description }}<br><br>{{ confidentiality.subdescription }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</main>
</template>
<script>
import text_en from '../text/en/home'
import text_es from '../text/es/home'
export default {
  data(){
    return{
      title: window.lang == 'es'? text_es.title : text_en.title,
      carousel: window.lang == 'es'? text_es.carousel : text_en.carousel,
      principles: window.lang == 'es'? text_es.principles : text_en.principles,
      mission: window.lang == 'es'? text_es.mission : text_en.mission,
      vision: window.lang == 'es'? text_es.vision : text_en.vision,
      values: window.lang == 'es'? text_es.values : text_en.values,
      images: window.lang == 'es'? text_es.images : text_en.images,
      control: window.lang == 'es'? text_es.control : text_en.control,
      confidentiality: window.lang == 'es'? text_es.confidentiality : text_en.confidentiality,
      globes: window.lang == 'es'? text_es.globes : text_en.globes,
      lang: window.lang
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue